type Props = {
    width?: number;
    height?: number;
    fill?: string;
}

const UploadIcon = ({
    width = 20,
    height = 20,
    fill = "none"
}: Props) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 20 20"
            fill={fill}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10 3.33333V13.3333M10 3.33333L6.66667 6.66667M10 3.33333L13.3333 6.66667"
                stroke="currentColor"
                strokeWidth="1.66667"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M3.33333 16.6667H16.6667"
                stroke="currentColor"
                strokeWidth="1.66667"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default UploadIcon;